angular.module('picmonicng').factory('UserPicmonicService', [
  'User',
  '$timeout',
  '$modal',
  'TopicTypesResource',
  function (User, $timeout, $modal, TopicTypesResource) {
    return {
      picmonics: [],
      getPicmonics: function () {
        this.picmonics = User.getv3({ resource: 'picmonics', per_page: -1 });
        return this.picmonics;
      },
      createNewPicmonic: function () {
        $modal.open({
          templateUrl: '/templates/modals/create-picmonic.html',
          windowClass: 'white-modal',
          backdropClass: 'below-nav',
          size: 'md',
          controller: [
            '$scope',
            '$modalInstance',
            '$state',
            'User',
            '$timeout',
            'UserService',
            function ($scope, $modalInstance, $state, User, $timeout, UserService) {
              $timeout(function () {
                angular.element('input[name=name]').focus();
              }, 0);

              $scope.loading = false;
              $scope.topicTypes = TopicTypesResource.query();

              $scope.createNewPicmonic = function () {
                if (!$scope.loading && $scope.create.$valid) {
                  $scope.loading = true;

                  if (!UserService.user.ugc_license) {
                    UserService.user.ugc_license = 1;
                    UserService.user.$update();
                  }

                  User.save({
                    resource: 'picmonics',
                    name: $scope.name,
                    topic_type_id: $scope.topic_type_id,
                  }).$promise.then(
                    function (picmonic) {
                      $state.go('app.editor', {
                        slug: picmonic.slug,
                        first_viewing: true,
                      });
                      $scope.close();
                    },
                    function () {
                      $scope.loading = false;
                    }
                  );
                }
              };

              $scope.close = function (event) {
                $modalInstance.close();
              };
            },
          ],
        });
      },
    };
  },
]);
